const aemon = require('aemon');

const {
  iconColors,
  iconSizes,
  iconTypes,
} = aemon.consumerGlobal;

const {
  ActivityCard,
  ActivityComment,
  Subheader,
  PURCHASE_UPDATED,
  PURCHASE_CLAIMED,
  MEMBER_INVITED,
  MEMBER_JOINED,
  MEMBER_WITHDREW,
  PURCHASE_TIPPED,
  PURCHASE_UNTIPPED,
  PAYMENT_AUTHORIZED,
  PAYMENT_AUTHORIZED_DEPOSIT,
  PAYMENT_AUTHORIZED_REGULAR,
  PAYMENT_AUTHORIZED_LAST,
  PAYMENT_CAPTURED,
  PURCHASE_COMPLETED,
  PURCHASE_COMMENT_CREATED,
  AddComment,
  Banner,
  Container,
  Divider,
  FacebookInput,
  GuestPasswordField,
  ModalBranding,
  PasswordField,
  Popover,
  PrimaryButton,
  PrimaryModal,
  SecondaryModal,
  Status,
  TextField,
} = aemon.consumerDesktop;

export {
  ActivityCard,
  ActivityComment,
  Subheader,
  PURCHASE_UPDATED,
  PURCHASE_CLAIMED,
  MEMBER_INVITED,
  MEMBER_JOINED,
  MEMBER_WITHDREW,
  PURCHASE_TIPPED,
  PURCHASE_UNTIPPED,
  PAYMENT_AUTHORIZED,
  PAYMENT_AUTHORIZED_DEPOSIT,
  PAYMENT_AUTHORIZED_REGULAR,
  PAYMENT_AUTHORIZED_LAST,
  PAYMENT_CAPTURED,
  PURCHASE_COMPLETED,
  PURCHASE_COMMENT_CREATED,
  AddComment,
  Banner,
  Divider,
  Container,
  FacebookInput,
  GuestPasswordField,
  ModalBranding,
  PasswordField,
  Popover,
  PrimaryButton,
  PrimaryModal,
  SecondaryModal,
  Status,
  TextField,
  iconColors,
  iconSizes,
  iconTypes,
};



// WEBPACK FOOTER //
// ./src/desktop/components/pbg-ui-library.js